import { useRef, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {Box,Button} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

import "./UploadFile.css";
import { fetchCustomerByuuid } from "../service";
import Footer from "../components/Footer";
import Header from "../components/Navigation.js";
import DragDrop from "../components/DragAndDrop";
import ButtonMailto from "../components/ButtonMailTo";
import MainTemplate from "../components/MainTemplate";

const UploadFile = (props) => {
  const filename = useRef();
  
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const { uuid } = useParams();
  const [phonenumber, setPhoneNumber] = useState("");
  const [fileUploadinProgress, setFileUploadInProgress] = useState(false);
  const [fileUploadFailed, setFileUploadFailed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getPhoneNumber = async () => {
      var response = await fetchCustomerByuuid(uuid);
      let result = await response.json()
      setPhoneNumber(result.customer_phone_number);
    }
    getPhoneNumber();
  }, [])

  return (
    <MainTemplate>
      <div class="center-content">
        <div className="header_box pt-2">
          <span className="header-icon">
          {/* <img src="../assets/img/Safe-Secure-Lock.png"></img> */}
          </span>
          <h2 className="headerStyle">SAFE AND SECURE</h2>
        </div>
        {phonenumber && <DragDrop phonenumber={phonenumber} />}
        {fileUploadinProgress && (
          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        )}
        {fileUploadFailed && (
          <div className="text-danger">File upload failed.</div>
        )}
        {uploadedFiles.map((file) => {
          return (
            <div class="container" key={uploadedFiles.indexOf(file)}>
              <div class="row align-items-center border">
                File uploaded - {file}
              </div>
            </div>
          );
        })}
        <div style={{textAlign:"center"}}>
          <div className="helpText">NEED HELP?</div>
          <div style={{ marginTop: "20px" }}>
            Bitcoin Depot is here to help!
            <br />
            Call or email for support.
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <a
              href="tel:678-435-9604"
              style={{
                color: "#212529",
                textDecoration: "none",
              }}
            >
              (678)435-9604
            </a>
            <br />
            <div>
              <ButtonMailto
                label="support@bitcoindepot.com"
                mailto="mailto:support@bitcoindepot.com"
                black
              />
            </div>
          </div>
        </div>
      </div>
    </MainTemplate>
  );
};

export default UploadFile;
